// extracted by mini-css-extract-plugin
module.exports = {"Container":"Animation_Container__1BBQo","Fountain":"Animation_Fountain__6Ix4m","Img":"Animation_Img__3yx1d"};